import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga4';
import './index.css';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';
import ErrorBoundary from './components/ErrorBoundary';

// Initialise Google Analytics 4. Guarded by the env var so dev environments
// without a measurement ID don't try to load the GA script. Set
// REACT_APP_GA_MEASUREMENT_ID=G-XXXXXXXXXX in `.env.production` to enable.
if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
  ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);
}

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const app = googleClientId ? (
  <GoogleOAuthProvider clientId={googleClientId}>
    <App />
  </GoogleOAuthProvider>
) : (
  <App />
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>{app}</ErrorBoundary>
  </React.StrictMode>
);
